module.exports = __webpack_public_path__ + "img/sample-error-3.e9b06a3.webp";